import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { ActivatedRouteSnapshot } from '@angular/router';
import { LiftRideService } from './lift-ride.service';
import { LiftRideCriteria } from '../models/lift-ride.criteria';

@Injectable({ providedIn: 'root' })
export class LiftRideResolver implements Resolve<any> {
  constructor(
    private liftRideService: LiftRideService
  ) { }

  resolve(route: ActivatedRouteSnapshot) {
    let rideCriteria = new LiftRideCriteria();
    rideCriteria.liftId = route.params.id;

    return this.liftRideService.getRides(rideCriteria.paramsExport());
  }
}
